import React from "react";
import { Music, Camera, Video, Paintbrush } from "lucide-react";

/**
 * Renders minimalist badge icons for athlete extras.
 * Props: athlete { musica, foto, video, pintura }
 * Size: pass `size` (default 12).
 */
export default function AthleteBadges({ athlete, size = 12, className = "" }) {
  if (!athlete) return null;
  const badges = [
    { flag: athlete.musica, Icon: Music, key: "musica", title: "Música" },
    { flag: athlete.foto, Icon: Camera, key: "foto", title: "Foto" },
    { flag: athlete.video, Icon: Video, key: "video", title: "Vídeo" },
    { flag: athlete.pintura, Icon: Paintbrush, key: "pintura", title: "Pintura" },
  ].filter((b) => !!b.flag);
  if (badges.length === 0) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 ml-2 align-middle text-[var(--text-secondary)] ${className}`}
      data-testid={`atleta-badges-${athlete.id}`}
    >
      {badges.map(({ Icon, key, title }) => (
        <Icon
          key={key}
          size={size}
          strokeWidth={2}
          data-testid={`badge-${key}-${athlete.id}`}
          aria-label={title}
        >
          <title>{title}</title>
        </Icon>
      ))}
    </span>
  );
}
